import { viewSettingsStore } from '@/features/viewSettings';
import { AnalyticsEvent, ClickSource } from '@/types/yametrika';

const YA_METRIKA_COUNTER_ID = 105521305;

const EVENTS_WITHOUT_VIEW: AnalyticsEvent[] = [
  AnalyticsEvent.changeLogColor,
  AnalyticsEvent.caldavConnect,
  AnalyticsEvent.caldavDisconnect,
  AnalyticsEvent.caldavSync,
  AnalyticsEvent.clickBugReport,
];

export class YaMetrikaStore {
  readonly id: number = YA_METRIKA_COUNTER_ID;

  private get isAvailable(): boolean {
    return typeof window.ym === 'function';
  }

  sendEvent = (event: AnalyticsEvent, payload?: Record<string, any>) => {
    if (!this.isAvailable) {
      if (import.meta.env.DEV) {
        console.log('[YaMetrika] sendEvent:', event, payload);
      }

      return;
    }

    const finalPayload = { ...payload };

    if (!EVENTS_WITHOUT_VIEW.includes(event)) {
      const view = viewSettingsStore.view;
      finalPayload.source = ClickSource[view];
    }

    window.ym(this.id, 'reachGoal', event, finalPayload);
  };

  viewPage = (url: string) => {
    if (!this.isAvailable) {
      return;
    }

    window.ym(this.id, 'hit', url);
  };
}

export const yaMetrikaStore = new YaMetrikaStore();
